/**
 * EditModeActions.js
 *
 * A component that renders the edit action button with different states
 * based on the current edit mode.
 *
 * Key Features:
 * - Toggles edit mode on/off
 * - Visual feedback through button styling
 * - Consistent placement in the UI
 *
 * Props:
 * @param {boolean} editMode - Whether edit mode is active
 * @param {Function} handleEditMode - Function to toggle edit mode
 */

// EditModeActions.js
import React from "react";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const EditModeActions = ({ editMode, handleEditMode }) => (
  <Button
    onClick={handleEditMode}
    startIcon={<EditIcon />}
    variant={editMode ? "contained" : "outlined"}
    size="small"
    sx={{ mr: 1 }}
  >
    Edit
  </Button>
);

export default EditModeActions;
